import { Button, Form, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { CreateTankHistoryRequest } from '@/types/apis/tankHistory/CreateTankHistoryRequest'

import { SpaceCustom } from '../../style'

type Props = {
  loading: boolean
  onSubmit: (formValues: CreateTankHistoryRequest) => void
  netWeightMl: number
}

type FormValues = {
  tankId: number
  quantity: number
}

const CreateTankHistoryComponentForm = ({ loading, onSubmit, netWeightMl }: Props) => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [form] = Form.useForm<FormValues>()

  const handleFinish = (values: FormValues) => {
    const formattedValues: CreateTankHistoryRequest = {
      tankId: Number(id),
      quantity: values.quantity,
    }

    onSubmit(formattedValues)
  }

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish}>
      <Form.Item
        label={t('components.pages.tankHistories.create.form.quantity')}
        name="quantity"
        rules={[{ required: true, message: t('components.pages.tankHistories.create.form.requireQuantity') }]}
      >
        <Input type="number" min={1} step={1} suffix="ケース" pattern="/^\d+$/" />
      </Form.Item>

      <Form.Item label={t('components.pages.tanks.list.table.netWeightMl')}>
        <Input type="number" suffix="ml" disabled value={netWeightMl} />
      </Form.Item>

      <SpaceCustom>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('components.pages.detergentHistories.create.form.submit')}
          </Button>
        </Form.Item>
      </SpaceCustom>
    </Form>
  )
}

CreateTankHistoryComponentForm.displayName = 'CreateTankHistoryComponentForm'
export default CreateTankHistoryComponentForm
